import React, { useCallback, useEffect , useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, Form, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteCityData, getCityList, updateCityStatusData } from "../../redux/actions/CityActions";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import Preloader from "../../Components/Preloader";
import { getAttendanceMonthlyDetailsList } from "../../redux/actions/AttendanceActions";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { CSVLink } from 'react-csv';
import { apiURL } from "../../axios";
import { getDisplayDateTimeFormat,getDateTimeMysqlFormatYm } from "../../util/generalUtills";


const MonthlyDetailsAttendance = () => {
  const { t } = useTranslation();
  const { id,month } = useParams();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [editCityId, setEditCityId] = useState(null);
  const {
    AuthReducer: { auth,errors,loading },
    attendanceReducers: {
      monthlyAttendancePermissions,
      monthlyAttendanceLists,
      loadingAttendance,
      errorsAttendance,
      monthlyAttendanceCount,
    },
  } = useSelector((city) => city);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(100);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  // const [month, setMonth] = useState(new Date());
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  const [showModal, setShowModal] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  const handleImageClick = (imageUrl) => {
    setImageUrl(imageUrl);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setImageUrl("")
  };
  
  
  const fetchCityList = useCallback(() => {
    if (auth?.token) {
      dispatch(getAttendanceMonthlyDetailsList(auth.token, paginate, page, search, sort,id,month));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCityList, 500, [auth, paginate, page, search, sort]);

  const csvHead = [['SR No.', 'Name', 'Contact Number', 'User Type',
    'City', 'Working Type', 'Login Time', 'Login Address', 'Logout Time', 'Logout Address']
  ]
  const csvData = monthlyAttendanceLists.map((cv, index) => {
    return [
      index + 1,
      cv?.name,
      cv?.phone || '',
      cv?.user_types || '',
      cv?.city + "," + cv?.states || '',
      cv?.type || 'Absent',
      cv?.createdAt ? getDisplayDateTimeFormat(cv?.createdAt) : '',
      cv?.login_address || '',
      cv?.logout_time!=null ? getDisplayDateTimeFormat(cv?.logout_time) : '',
      cv?.logout_address || ''
    ];
  });
  const exportData = csvHead.concat(csvData);

  useEffect(() => {
    if(errors)
    {
      if(errors?.status==401)
      {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  },[errors])

  useEffect(() => {
    document.title = `Monthly Attendance Details :: ${auth?.generalSettings?.title}`;
  }, []);

  const monthNames = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];

  const printTable = () => {
    const tableElement = document.getElementById('table-to-print');
    if (!tableElement) {
      console.error("Table element not found!");
      return;
    }
  
    const tableContent = tableElement.outerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
  
    printWindow.document.write(`
      <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
          }
          img {
            width: 70px; /* Fixed width */
            height: 70px; /* Fixed height (Square) */
            object-fit: cover; /* Ensure the image fills the square */
            border-radius: 5px; /* Slight rounding */
            display: block;
            margin: auto;
          }
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        <h2 style="text-align:center;">${document.title}</h2>
        ${tableContent}
        <p style="text-align:center;">This is a system-generated report and does not require a signature or stamp.</p>
        <script>
          function loadImagesAndPrint() {
            const images = document.images;
            let loadedCount = 0;
            if (images.length === 0) {
              window.print();
              return;
            }
            for (let img of images) {
              if (img.complete) {
                loadedCount++;
              } else {
                img.onload = () => {
                  loadedCount++;
                  if (loadedCount === images.length) {
                    window.print();
                  }
                };
                img.onerror = () => {
                  loadedCount++;
                  if (loadedCount === images.length) {
                    window.print();
                  }
                };
              }
            }
          }
          loadImagesAndPrint();
          window.onafterprint = function() { window.close(); };
        </script>
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
  };  
  
  

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Monthly Attendance"), path: "/Attendance/Monthly", active: false },
          { label: t("Monthly Attendance Details"), path: "/Attendance/Monthly", active: true },
        ]}
        title={t(`${monthNames[new Date(month).getMonth()]} Month Attendance Details `)}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={6}></Col>
                  <Col lg={6}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        <Button variant="dark" onClick={printTable}>
                          <i className="mdi mdi-printer me-1"></i>Print
                        </Button>

                        {(monthlyAttendanceLists?.excel ) && (
                          <>
                            <CSVLink
                              filename="daily-attendance-reports.csv"
                              data={exportData}
                              className="btn btn-info text-white ms-1"
                              title="Export To CSV"
                            >
                              <i className="mdi mdi-file-excel me-1"></i>
                              Excel
                            </CSVLink>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div style={{overflowY:'auto',maxHeight:'500px',border: "1px solid #dee2e6"}}>
                <Table className="mb-0 table-bordered"
                  id="table-to-print"
                  size="sm"
                  striped
                  responsive
                  >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>User Type</th>
                      <th>City</th>
                      <th>Working Type</th>
                      <th>Login Time</th>
                      <th>Logout Time</th>
                      <th>Login Photo</th>
                      <th>Logout Photo</th>
                    </tr>
                  </thead>
                  <tbody>
                  {monthlyAttendanceLists.length === 0 ? (
                    <tr>
                      <td colSpan="12">No data found</td>
                    </tr>
                  ) : (<>
                    {monthlyAttendanceLists?.map?.((item, index) => {
                      return (
                        <tr key={item.id}>
                          <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                          <td>{item?.userIdAttendance?.name}</td>
                          <td>{item?.userIdAttendance?.phone}</td>
                          <td>{item?.userIdAttendance?.adminUserType?.name}</td>
                          <td>{item?.userIdAttendance?.citiesAdminUsers?.city_name}, {item?.userIdAttendance?.citiesAdminUsers?.cities_state?.state_name}</td>
                          <td>{
                            item?.type=="Present" ? 
                              <>
                                <Badge className={"bg-success"}>
                                  {item?.type}
                                </Badge>
                              </>
                              : item?.type=="Leave" 
                              ? 
                              <>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-created-at">
                                        {`${item?.leave_remark}`}
                                      </Tooltip>
                                    }
                                  >
                                  <Badge className={"bg-warning"}>
                                  {item?.type}
                                  </Badge>
                                </OverlayTrigger>
                              </>
                              : 
                              <>
                                <Badge className={"bg-danger"}>
                                {item?.type}
                                </Badge>
                              </>
                              }</td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-created-at">
                                  {item?.login_address}
                                </Tooltip>
                              }
                            >
                              <span className="d-inline-block" tabIndex="0">
                                {item?.createdAt ? getDisplayDateTimeFormat(item?.createdAt) : ''}
                              </span>
                            </OverlayTrigger>
                          </td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-created-at">
                                  {item?.logout_address}
                                </Tooltip>
                              }
                            >
                              <span className="d-inline-block" tabIndex="0">
                              {item?.logout_time!=null ? getDisplayDateTimeFormat(item?.logout_time) : ''}
                              </span>
                            </OverlayTrigger>
                          </td>
                          <td>
                          {item?.createdAt != null ? (
                            <img 
                              className="avatar-md rounded" 
                              src={`${auth?.generalSettings?.app_url}/uploads/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.login_image}`} 
                              onClick={() => handleImageClick(`${auth?.generalSettings?.app_url}/uploads/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.login_image}`)} 
                              alt="Login Image"
                            />
                          ) : ''}
                          </td>
                          <td>
                          {item?.logout_time != null ? (
                            <img 
                              className="avatar-md rounded" 
                              src={`${auth?.generalSettings?.app_url}/uploads/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.logout_image}`}
                              onClick={() => handleImageClick(`${auth?.generalSettings?.app_url}/uploads/uploads/${getDateTimeMysqlFormatYm(item?.createdAt)}/attendance/${item?.logout_image}`)} 
                              alt="Login Image"
                            />
                          ) : ''}
                          </td>
                        </tr>
                      );
                    })}</>
                  )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal show={showModal} onHide={handleClose} size="md">
        <Modal.Body>
          <img
            src={imageUrl}
            alt="Full size"
            className="img-fluid"
          />
        </Modal.Body>
      </Modal>
      
      {loadingAttendance && (<Preloader/>)}
    </>
  );
};

export default MonthlyDetailsAttendance;
